import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserTeamInfo } from "JS/Models";
import { FycStatus } from "JS/Models/FycStatus";

export interface HomeState {
    userTeamInformation?: UserTeamInfo;
    fycStatusInfo?: FycStatus | undefined;
    landingPageJson?: any;
}

const initialState: HomeState = {
    userTeamInformation: {
        teamName: "",
        testUser: false,
        activeSubscriptions: [],
    },
    fycStatusInfo: undefined,
    landingPageJson: {},
};

export const homeStateSlice = createSlice({
    name: "homeState",
    initialState,
    reducers: {
        setUserTeamInfo: (state, data: PayloadAction<HomeState>) => {
            state.userTeamInformation = data.payload.userTeamInformation;

            return state;
        },
        setFycStatusInfo: (state, data: PayloadAction<HomeState>) => {
            state.fycStatusInfo = data.payload.fycStatusInfo;

            return state;
        },
        setLandingPageJson: (state, data: PayloadAction<HomeState>) => {
            state.landingPageJson = data.payload.landingPageJson;

            return state;
        },
        resetHomeState: () => {
            return initialState;
        },
    },
});
export const {
    setUserTeamInfo,
    setFycStatusInfo,
    setLandingPageJson,
    resetHomeState,
} = homeStateSlice.actions;
